export function resolveActiveCompanyId(companies, storedCompanyId) {
  const list = Array.isArray(companies) ? companies : [];
  if (storedCompanyId && list.some((company) => company.id === storedCompanyId)) {
    return storedCompanyId;
  }
  return list[0]?.id || "";
}
